import React, { Children, isValidElement } from 'react'

import Box from '@ui-kit/components/layoutComponents/Box/index.native'
import Spacer from '@ui-kit/components/layoutComponents/Spacer/'

import * as styles from './styles'
import type { NativeProps } from './types'

/**
 * @deprecated These components is deprecated and will be removed when usage is 0%.
 * Please use the View from react-native instead with Tailwind styles.
 */
const Stack = (props: NativeProps): JSX.Element => {
  const { space, ...boxProps } = props
  const stackItems = Children.toArray(props.children)
    .filter(isValidElement)
    .map((child, index, children) => {
      return index !== Children.count(children) - 1
        ? [
            child,
            <Spacer size={space || styles.DEFAULT_SPACE} key={`spacer-${index.toString()}`} />,
          ]
        : child
    })
  return <Box {...boxProps}>{stackItems}</Box>
}

export default Stack
